import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/auth.models';
import { ApiserviceService } from './apiservice.service';

@Injectable({ providedIn: 'root' })
export class AuthfakeauthenticationService {
    private currentUserSubject: BehaviorSubject<any | null>;
    public currentUser: Observable<any | null>;

    // 1. Lisans bilgisi için yeni BehaviorSubject ve Observable
    private currentLicenseSubject: BehaviorSubject<any | null>;
    public currentLicense$: Observable<any | null>;

    personelstorage = [];
   

    constructor(private http: HttpClient, private api: ApiserviceService) {
        this.currentUserSubject = new BehaviorSubject<User | null>(JSON.parse(sessionStorage.getItem('kullanici') || 'null'));
        this.currentUser = this.currentUserSubject.asObservable();

        // 2. Hafızadaki lisansı yükle
        this.currentLicenseSubject = new BehaviorSubject<any | null>(JSON.parse(sessionStorage.getItem('lisans') || 'null'));
        this.currentLicense$ = this.currentLicenseSubject.asObservable();

        // Uygulama ilk açıldığında oturum açık ama lisans bilgisi yoksa veya güncellenmesi gerekiyorsa otomatik çek
        if (this.currentUserValue) {
            this.loadLicenseInfo();
        }
    }

    public get currentUserValue(): User | null {
        return this.currentUserSubject.value;
    }

    // 3. Anlık lisans verisine erişim için getter
    public get currentLicenseValue(): any | null {
        return this.currentLicenseSubject.value;
    }

    async login(email: string, password: string, recaptchaToken: string) {
        const user: any = await this.api.post('user/login', { 
            email, 
            password, 
            recaptcha_token: recaptchaToken 
        });

        if (user && user.status === 200) {
            sessionStorage.setItem('kullanici', JSON.stringify(user));
            this.currentUserSubject.next(user);

            // Login başarılı olduğunda lisans bilgisini de yükleyelim
            await this.loadLicenseInfo();
        }

        return user;
    }

    // 4. Lisans bilgisini API'den çekip cache'leyen metot
    async loadLicenseInfo() {
        
        const userId = this.currentUserValue?.data?.kid;
      
        if (!userId) return null;
       
        try {
            const res: any = await this.api.post('lisans/getbyid', { id: userId });
            const lisansData = res?.data?.[0] || null;
          
            if (lisansData) {
                sessionStorage.setItem('lisans', JSON.stringify(lisansData));
                this.currentLicenseSubject.next(lisansData);
            }
            return lisansData;
        } catch (error) {
            console.error('Lisans bilgisi yüklenirken hata oluştu:', error);
            return null;
        }
    }

    // Lisans aktif mi, paketi var mı, tarihi geçmemiş mi toplu kontrol
  public isLicenseValid(): boolean {
    const license = this.currentLicenseValue;
    console.log('Lisans kontrolü yapılıyor:', license);
    // 1. Lisans verisi hiç yoksa geçersizdir
    if (!license) return false;

    // 2. Paket seviyesi 0 ise geçersizdir
    const paket = Number(license.paket || 0);
    if (paket === 0) return false;

    // 3. Durum 0 (pasif) ise geçersizdir
    const durum = Number(license.durum ?? 1); // Eğer durum alanı dönmüyorsa varsayılan aktif kabul edilebilir
    if (durum === 0) return false;

    // 4. bit_tarih kontrolü (Tarih dolmuş mu?)
    if (license.bit_tarih) {
      const bitTarihi = new Date(license.bit_tarih).getTime();
      const simdi = new Date().getTime();

      // Eğer bitiş tarihi bugünden küçükse (tarih geçmişse) geçersizdir
      if (bitTarihi < simdi) {
        return false;
      }
    }

    return true;
  }

    logout() {
        sessionStorage.removeItem('kullanici');
        sessionStorage.removeItem('lisans');
        this.currentUserSubject.next(null);
        this.currentLicenseSubject.next(null);
    }
}